var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4bbf7a36f1fab999469ddc2efdbebcf2c2bae84d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["busbud-pubweb-prod@busbudcom"]={id:"4bbf7a36f1fab999469ddc2efdbebcf2c2bae84d"};
      